// import React from "react";
// import { Rocket, Briefcase } from "lucide-react";
// import { Link } from "react-router-dom";

// export function HeroSection() {
//   return (
//     <section
//       className="relative bg-gradient-to-r from-[#0F172A] via-[#1E293B] to-[#1E1B4B] text-white min-h-screen flex items-center px-4 md:px-20 py-10 overflow-hidden"
//       style={{
//         backgroundImage: `url("./assets/191475-large-background-gradient-1920x1080.jpg")`,
//         backgroundRepeat: "no-repeat",
//         backgroundSize: "cover",
//         backgroundPosition: "center",
//       }}
//     >
//       <div className="max-w-7xl mx-auto w-full flex flex-col md:flex-row items-center justify-between relative space-y-10 md:space-y-0">
//         {/* LEFT CONTENT (Text, Buttons, Stats) */}
//         <div
//           className="flex flex-col items-start text-left space-y-6 md:w-1/2"
//           data-aos="fade-right"
//         >
//           <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold leading-tight text-white mt-10">
//             Transform Your Career <br />
//             <span className="text-fuchsia-400">with CSG Education</span>
//           </h1>

//           <p className="text-base md:text-lg text-gray-200 max-w-lg">
//             Master cutting-edge technologies with our industry-expert trainers.
//             Get job-ready skills in software & hardware development, multimedia,
//             and more.
//           </p>

//           {/* ✅ Stats Section */}
//           <div className="flex flex-row flex-wrap gap-6 pt-2">
//             <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl px-5 py-3 flex items-center gap-3 shadow-lg hover:shadow-fuchsia-500/30 transition-transform duration-300 hover:scale-105">
//               <Briefcase className="w-8 h-8 text-fuchsia-400 bg-white/20 rounded-full p-1" />
//               <div>
//                 <h4 className="text-xl font-semibold text-white">100%</h4>
//                 <p className="text-sm text-gray-200">Placement Rate</p>
//               </div>
//             </div>

//             <div className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl px-5 py-3 flex items-center gap-3 shadow-lg hover:shadow-pink-500/30 transition-transform duration-300 hover:scale-105">
//               <Rocket className="w-8 h-8 text-pink-400 bg-white/20 rounded-full p-1" />
//               <div>
//                 <h4 className="text-xl font-semibold text-white">50+</h4>
//                 <p className="text-sm text-gray-200">Industry Partners</p>
//               </div>
//             </div>
//           </div>

//           {/* ✅ Buttons */}
//           <div className="flex flex-wrap gap-4 pt-4">
//             <Link to="/all-offeres">
//               <button
//                 className="relative bg-gradient-to-r from-fuchsia-500 via-pink-500 to-purple-500
//                 font-semibold px-6 py-3.5 text-sm md:text-base rounded-md shadow-lg
//                 transition-transform duration-300 ease-in-out transform hover:scale-110"
//               >
//                 <span className="animate-text-blink">Courses Offered</span>
//               </button>
//             </Link>

//             <Link to="/contact">
//               <button className="border text-white hover:bg-blue-400 hover:text-black px-6 py-3.5 text-sm rounded-md transition">
//                 Contact Us
//               </button>
//             </Link>
//           </div>
//         </div>

//         {/* RIGHT SIDE SECTION (LOGOS + MAIN IMAGE) */}
//         <div
//           className="md:w-1/2 flex flex-col md:flex-row items-center md:justify-end gap-6"
//           data-aos="fade-left"
//         >
//           {/* LEFT + RIGHT LOGOS (STACKED) */}
//           <div className="flex flex-col items-center gap-4">
//             <img
//               src="/left.png"
//               alt="Left Logo"
//               className="w-28 h-28 md:w-32 md:h-32 object-contain drop-shadow-lg"
//               data-aos="fade-right"
//             />
//             <img
//               src="/right.png"
//               alt="Right Logo"
//               className="w-28 h-28 md:w-32 md:h-32 object-contain drop-shadow-lg"
//               data-aos="fade-up"
//             />
//           </div>

//           {/* MAIN BIG IMAGE */}
//           <img
//             src="./assets/6be7f7756b8f4737a25c69f1086dfffb.jpg"
//             alt="Education Illustration"
//             className="w-72 h-72 md:w-[480px] md:h-[480px] object-contain drop-shadow-2xl rounded-2xl"
//           />
//         </div>
//       </div>
//     </section>
//   );
// }

// import React from "react";
// import { Rocket, Briefcase } from "lucide-react";
// import { Link } from "react-router-dom";

// export function HeroSection() {
//   return (
//     <section className="relative bg-sky-300 text-gray-900 min-h-screen flex flex-col items-center px-4 md:px-20 pt-6 pb-10 overflow-hidden">
//       {/* ✅ TOP HEADER BAR (TIGHTLY ALIGNED) */}
//       <div className="w-full flex items-center justify-center gap-3 md:gap-6 mt-20">
//         <img
//           src="/left.png"
//           alt="Left Logo"
//           className="w-14 h-14 md:w-20 md:h-20 object-contain"
//         />

//         {/* <h2 className="text-xl md:text-5xl font-bold text-center text-gray-900">
//           CSG <span className="text-fuchsia-600">Computer Education</span>
//         </h2> */}

// <Link
//   to="/"
//   style={{ animation: "zoomInOut 2.5s ease-in-out infinite" }}
//   className="text-5xl font-bold bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 bg-clip-text text-transparent transition-all duration-300 hover:drop-shadow-md hover:scale-105"
// >
//   CSG Computer Education
// </Link>

//         <img
//           src="/right.png"
//           alt="Right Logo"
//           className="w-14 h-14 md:w-20 md:h-20 object-contain"
//         />
//       </div>

//       {/* ✅ MAIN HERO CONTENT (REDUCED TOP GAP) */}
//       <div className="max-w-7xl mx-auto w-full flex flex-col md:flex-row items-center justify-between relative mt-6 md:mt-8">
//         {/* LEFT CONTENT */}
//         <div
//           className="flex flex-col items-start text-left space-y-6 md:w-1/2"
//           data-aos="fade-right"
//         >
//           <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold leading-tight text-gray-900 mt-2">
//             Transform Your Career <br />
//             <span className="text-fuchsia-600">with CSG Education</span>
//           </h1>

//           <p className="text-base md:text-lg text-gray-700 max-w-lg">
//             Master cutting-edge technologies with our industry-expert trainers.
//             Get job-ready skills in software & hardware development, multimedia,
//             and more.
//           </p>

//           {/* Stats Section */}
//           <div className="flex flex-row flex-wrap gap-6 pt-2">
//             <div className="bg-fuchsia-50 border border-fuchsia-200 rounded-2xl px-5 py-3 flex items-center gap-3 shadow-sm hover:shadow-fuchsia-200 transition-transform duration-300 hover:scale-105">
//               <Briefcase className="w-8 h-8 text-fuchsia-600 bg-fuchsia-100 rounded-full p-1" />
//               <div>
//                 <h4 className="text-xl font-semibold text-gray-900">100%</h4>
//                 <p className="text-sm text-gray-600">Placement Rate</p>
//               </div>
//             </div>

//             <div className="bg-purple-50 border border-purple-200 rounded-2xl px-5 py-3 flex items-center gap-3 shadow-sm hover:shadow-purple-200 transition-transform duration-300 hover:scale-105">
//               <Rocket className="w-8 h-8 text-purple-600 bg-purple-100 rounded-full p-1" />
//               <div>
//                 <h4 className="text-xl font-semibold text-gray-900">50+</h4>
//                 <p className="text-sm text-gray-600">Industry Partners</p>
//               </div>
//             </div>
//           </div>

//           {/* Buttons */}
//           <div className="flex flex-wrap gap-4 pt-4">
//             <Link to="/all-offeres">
//               <button
//                 className="relative bg-gradient-to-r from-fuchsia-500 via-pink-500 to-purple-500
//                 font-semibold px-6 py-3.5 text-sm md:text-base rounded-md shadow-md
//                 transition-transform duration-300 ease-in-out transform hover:scale-110 text-white"
//               >
//                 Courses Offered
//               </button>
//             </Link>

//             <Link to="/contact">
//               <button className="border border-gray-800 text-gray-900 hover:bg-gray-900 hover:text-white px-6 py-3.5 text-sm rounded-md transition">
//                 Contact Us
//               </button>
//             </Link>
//           </div>
//         </div>

//         {/* ✅ RIGHT IMAGE (LARGE & ALIGNED) */}
//         <div
//           className="md:w-1/2 flex justify-center md:justify-end mt-8 md:mt-0"
//           data-aos="fade-left"
//         >
//           <img
//             src="./assets/6be7f7756b8f4737a25c69f1086dfffb.jpg"
//             alt="Education Illustration"
//             className="w-80 h-80 md:w-[520px] md:h-[520px] object-contain drop-shadow-xl rounded-2xl"
//           />
//         </div>
//       </div>
//     </section>
//   );
// }

// import React from "react";
// import { Rocket, Briefcase } from "lucide-react";
// import { Link } from "react-router-dom";

// export function HeroSection() {
//   return (
//     <section className="relative bg-sky-300 text-gray-900 min-h-screen flex flex-col items-center px-4 md:px-20 py-10 overflow-hidden">
//       {/* ✅ TOP HEADER BAR */}
//       <div className="w-full flex items-center justify-between mb-10 mt-10">
//         <img
//           src="/left.png"
//           alt="Left Logo"
//           className="w-20 h-20 md:w-28 md:h-28 object-contain"
//         />

//         <Link
//           to="/"
//           style={{ animation: "zoomInOut 2.5s ease-in-out infinite" }}
//           className="text-5xl font-bold bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 bg-clip-text text-transparent transition-all duration-300 hover:drop-shadow-md hover:scale-105"
//         >
//           CSG Computer Education
//         </Link>

//         <img
//           src="/right.png"
//           alt="Right Logo"
//           className="w-20 h-20 md:w-28 md:h-28 object-contain"
//         />
//       </div>

//       {/* ✅ MAIN HERO CONTENT */}
//       <div className="max-w-7xl mx-auto w-full flex flex-col md:flex-row items-center justify-between relative space-y-10 md:space-y-0">
//         {/* LEFT CONTENT (Text, Buttons, Stats) */}
//         <div
//           className="flex flex-col items-start text-left space-y-6 md:w-1/2"
//           data-aos="fade-right"
//         >
//           <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold leading-tight text-gray-900 mt-4">
//             Transform Your Career <br />
//             <span className="text-fuchsia-600">with CSG Education</span>
//           </h1>

//           <p className="text-base md:text-lg text-gray-700 max-w-lg">
//             Master cutting-edge technologies with our industry-expert trainers.
//             Get job-ready skills in software & hardware development, multimedia,
//             and more.
//           </p>

//           {/* Stats Section */}
//           <div className="flex flex-row flex-wrap gap-6 pt-2">
//             <div className="bg-fuchsia-50 border border-fuchsia-200 rounded-2xl px-5 py-3 flex items-center gap-3 shadow-sm hover:shadow-fuchsia-200 transition-transform duration-300 hover:scale-105">
//               <Briefcase className="w-8 h-8 text-fuchsia-600 bg-fuchsia-100 rounded-full p-1" />
//               <div>
//                 <h4 className="text-xl font-semibold text-gray-900">100%</h4>
//                 <p className="text-sm text-gray-600">Placement Rate</p>
//               </div>
//             </div>

//             <div className="bg-purple-50 border border-purple-200 rounded-2xl px-5 py-3 flex items-center gap-3 shadow-sm hover:shadow-purple-200 transition-transform duration-300 hover:scale-105">
//               <Rocket className="w-8 h-8 text-purple-600 bg-purple-100 rounded-full p-1" />
//               <div>
//                 <h4 className="text-xl font-semibold text-gray-900">50+</h4>
//                 <p className="text-sm text-gray-600">Industry Partners</p>
//               </div>
//             </div>
//           </div>

//           {/* Buttons */}
//           <div className="flex flex-wrap gap-4 pt-4">
//             <Link to="/all-offeres">
//               <button
//                 className="relative bg-gradient-to-r from-fuchsia-500 via-pink-500 to-purple-500
//                 font-semibold px-6 py-3.5 text-sm md:text-base rounded-md shadow-md
//                 transition-transform duration-300 ease-in-out transform hover:scale-110 text-white"
//               >
//                 Courses Offered
//               </button>
//             </Link>

//             <Link to="/contact">
//               <button
//                 className="relative bg-gradient-to-r from-fuchsia-500 via-pink-500 to-purple-500
//                 font-semibold px-6 py-3.5 text-sm md:text-base rounded-md shadow-md
//                 transition-transform duration-300 ease-in-out transform hover:scale-110 text-white"
//               >
//                 Contact Us
//               </button>
//             </Link>
//           </div>
//         </div>

//         {/* ✅ RIGHT IMAGE (Bigger Size) */}
//         <div
//           className="md:w-1/2 flex justify-center md:justify-end"
//           data-aos="fade-left"
//         >
//           <img
//             src="./assets/6be7f7756b8f4737a25c69f1086dfffb.jpg"
//             alt="Education Illustration"
//             className="w-80 h-80 md:w-[650px] md:h-[520px] object-contain drop-shadow-xl rounded-2xl"
//           />
//         </div>
//       </div>
//     </section>
//   );
// }

// import React from "react";
// import { Rocket, Briefcase } from "lucide-react";
// import { Link } from "react-router-dom";

// export function HeroSection() {
//   return (
//     <section className="relative bg-sky-300 text-gray-900 min-h-screen flex flex-col items-center px-4 md:px-20 py-10 overflow-hidden">
//       {/* ✅ TOP HEADER BAR (keep mt-10 for navbar, reduce mb for smaller gap) */}
//       <div className="w-full flex items-center justify-between mt-10 mb-4">
//         <img
//           src="/left.png"
//           alt="Left Logo"
//           className="w-20 h-20 md:w-28 md:h-28 object-contain"
//         />

//         <Link
//           to="/"
//           style={{ animation: "zoomInOut 2.5s ease-in-out infinite" }}
//           className="text-5xl font-bold bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 bg-clip-text text-transparent transition-all duration-300 hover:drop-shadow-md hover:scale-105"
//         >
//           CSG Computer Education
//         </Link>

//         <img
//           src="/right.png"
//           alt="Right Logo"
//           className="w-20 h-20 md:w-28 md:h-28 object-contain"
//         />
//       </div>

//       {/* ✅ MAIN HERO CONTENT (reduced top gap) */}
//       <div className="max-w-7xl mx-auto w-full flex flex-col md:flex-row items-center justify-between relative space-y-6 md:space-y-0 mt-0">
//         {/* LEFT CONTENT (Text, Buttons, Stats) */}
//         <div
//           className="flex flex-col items-start text-left space-y-5 md:w-1/2"
//           data-aos="fade-right"
//         >
//           <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold leading-tight text-gray-900">
//             Transform Your Career <br />
//             <span className="text-fuchsia-600">with CSG Education</span>
//           </h1>

//           <p className="text-base md:text-lg text-gray-700 max-w-lg">
//             Master cutting-edge technologies with our industry-expert trainers.
//             Get job-ready skills in software & hardware development, multimedia,
//             and more.
//           </p>

//           {/* Stats Section */}
//           <div className="flex flex-row flex-wrap gap-6 pt-2">
//             <div className="bg-fuchsia-50 border border-fuchsia-200 rounded-2xl px-5 py-3 flex items-center gap-3 shadow-sm hover:shadow-fuchsia-200 transition-transform duration-300 hover:scale-105">
//               <Briefcase className="w-8 h-8 text-fuchsia-600 bg-fuchsia-100 rounded-full p-1" />
//               <div>
//                 <h4 className="text-xl font-semibold text-gray-900">100%</h4>
//                 <p className="text-sm text-gray-600">Placement Rate</p>
//               </div>
//             </div>

//             <div className="bg-purple-50 border border-purple-200 rounded-2xl px-5 py-3 flex items-center gap-3 shadow-sm hover:shadow-purple-200 transition-transform duration-300 hover:scale-105">
//               <Rocket className="w-8 h-8 text-purple-600 bg-purple-100 rounded-full p-1" />
//               <div>
//                 <h4 className="text-xl font-semibold text-gray-900">50+</h4>
//                 <p className="text-sm text-gray-600">Industry Partners</p>
//               </div>
//             </div>
//           </div>

//           {/* Buttons */}
//           <div className="flex flex-wrap gap-4 pt-2">
//             <Link to="/all-offeres">
//               <button
//                 className="relative bg-gradient-to-r from-fuchsia-500 via-pink-500 to-purple-500
//                 font-semibold px-6 py-3.5 text-sm md:text-base rounded-md shadow-md
//                 transition-transform duration-300 ease-in-out transform hover:scale-110 text-white"
//               >
//                 Courses Offered
//               </button>
//             </Link>

//             <Link to="/contact">
//               <button
//                 className="relative bg-gradient-to-r from-fuchsia-500 via-pink-500 to-purple-500
//                 font-semibold px-6 py-3.5 text-sm md:text-base rounded-md shadow-md
//                 transition-transform duration-300 ease-in-out transform hover:scale-110 text-white"
//               >
//                 Contact Us
//               </button>
//             </Link>
//           </div>
//         </div>

//         {/* ✅ RIGHT IMAGE */}
//         <div
//           className="md:w-1/2 flex justify-center md:justify-end"
//           data-aos="fade-left"
//         >
//           <img
//             src="./assets/6be7f7756b8f4737a25c69f1086dfffb.jpg"
//             alt="Education Illustration"
//             className="w-80 h-80 md:w-[650px] md:h-[520px] object-contain drop-shadow-xl rounded-2xl"
//           />
//         </div>
//       </div>
//     </section>
//   );
// }

// import React from "react";
// import { Rocket, Briefcase } from "lucide-react";
// import { Link } from "react-router-dom";

// export function HeroSection() {
//   return (
//     <section className="relative bg-sky-300 text-gray-900 h-screen flex flex-col items-center justify-between px-4 md:px-20 py-6 overflow-hidden">
//       {/* ✅ TOP HEADER BAR (smaller height for balance) */}
//       <div className="w-full flex items-center justify-between mt-20 md:mt-6 ">
//         <img
//           src="/left.png"
//           alt="Left Logo"
//           className="w-16 h-16 md:w-24 md:h-24 object-contain mt-10"
//         />

// <Link
//   to="/"
//   className="text-5xl font-bold leading-fix zoomInOut bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500
//    bg-clip-text text-transparent transition-all duration-300 hover:drop-shadow-md hover:scale-105 text-center mt-10 mb-2"
// >
//   Authorised Training Centre
// </Link>

//         <img
//           src="/right.png"
//           alt="Right Logo"
//           className="w-16 h-16 md:w-24 md:h-24 object-contain mt-10"
//         />
//       </div>

//       {/* ✅ MAIN HERO CONTENT */}
//       <div className="flex flex-col md:flex-row items-center justify-between w-full flex-grow max-w-7xl mx-auto">
//         {/* LEFT SIDE CONTENT */}
//         <div
//           className="flex flex-col justify-center items-start text-left space-y-4 md:w-1/2"
//           data-aos="fade-right"
//         >
//           <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold leading-tight text-gray-900">
//             Transform Your Career <br />
//             <span className="text-fuchsia-600">with CSG Education</span>
//           </h1>

//           <p className="text-base md:text-lg text-gray-700 max-w-lg">
//             Master cutting-edge technologies with our industry-expert trainers.
//             Get job-ready skills in software & hardware development, multimedia,
//             and more.
//           </p>

//           {/* Stats */}
//           <div className="flex flex-row flex-wrap gap-4 pt-2">
//             <div className="bg-fuchsia-50 border border-fuchsia-200 rounded-2xl px-4 py-3 flex items-center gap-3 shadow-sm hover:shadow-fuchsia-200 transition-transform duration-300 hover:scale-105">
//               <Briefcase className="w-8 h-8 text-fuchsia-600 bg-fuchsia-100 rounded-full p-1" />
//               <div>
//                 <h4 className="text-lg md:text-xl font-semibold text-gray-900">
//                   100%
//                 </h4>
//                 <p className="text-sm text-gray-600">Placement Rate</p>
//               </div>
//             </div>

//             <div className="bg-purple-50 border border-purple-200 rounded-2xl px-4 py-3 flex items-center gap-3 shadow-sm hover:shadow-purple-200 transition-transform duration-300 hover:scale-105">
//               <Rocket className="w-8 h-8 text-purple-600 bg-purple-100 rounded-full p-1" />
//               <div>
//                 <h4 className="text-lg md:text-xl font-semibold text-gray-900">
//                   50+
//                 </h4>
//                 <p className="text-sm text-gray-600">Industry Partners</p>
//               </div>
//             </div>
//           </div>

//           {/* Buttons */}
//           <div className="flex flex-wrap gap-4 pt-2">
//             <Link to="/all-offeres">
//               <button
//                 className="relative bg-gradient-to-r from-fuchsia-500 via-pink-500 to-purple-500
//                 font-semibold px-6 py-3 text-sm md:text-base rounded-md shadow-md
//                 transition-transform duration-300 ease-in-out transform hover:scale-110 text-white"
//               >
//                 Courses Offered
//               </button>
//             </Link>

//             <Link to="/contact">
//               <button
//                 className="relative bg-gradient-to-r from-fuchsia-500 via-pink-500 to-purple-500
//                 font-semibold px-6 py-3 text-sm md:text-base rounded-md shadow-md
//                 transition-transform duration-300 ease-in-out transform hover:scale-110 text-white"
//               >
//                 Contact Us
//               </button>
//             </Link>
//           </div>
//         </div>

//         {/* ✅ RIGHT SIDE IMAGE */}
//         <div
//           className="md:w-1/2 flex justify-center md:justify-end"
//           data-aos="fade-left"
//         >
//           <img
//             src="./assets/6be7f7756b8f4737a25c69f1086dfffb.jpg"
//             alt="Education Illustration"
//             className="w-64 h-64 md:w-[600px] md:h-[420px] object-contain drop-shadow-xl rounded-2xl"
//           />
//         </div>
//       </div>

//       {/* ✅ FOOTER SPACER (optional if too tight) */}
//       <div className="h-4 md:h-8"></div>
//     </section>
//   );
// }

//final
// import React from "react";
// import { Rocket, Briefcase } from "lucide-react";
// import { Link } from "react-router-dom";

// export function HeroSection() {
//   return (
//     <section className="relative bg-sky-300 text-gray-900 min-h-screen flex flex-col items-center justify-between px-4 md:px-20 py-6 overflow-hidden">
//       {/* ✅ TOP HEADER BAR (with more top margin in mobile) */}
//       <div className="w-full flex items-center justify-between flex-wrap gap-4 md:gap-0 mt-10 md:mt-6">
//         {/* Left Logo */}
//         <img
//           src="/left.png"
//           alt="Left Logo"
//           className="w-14 h-14 sm:w-16 sm:h-16 md:w-24 md:h-24 object-contain mt-10"
//         />

//         {/* Center Title */}

//         <Link
//           to="/"
//           style={{ animation: "zoomInOut 2.5s ease-in-out infinite" }}
//           className="text-2xl leading-fix sm:text-3xl md:text-5xl font-bold bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500
//           bg-clip-text text-transparent transition-all duration-300 hover:drop-shadow-md hover:scale-105 text-center flex-1 mt-10 pb-2 overflow-visible"
//         >
//           Authorised Training Centre
//         </Link>

//         {/* Right Logo */}
//         <img
//           src="/right.png"
//           alt="Right Logo"
//           className="w-14 h-14 sm:w-16 sm:h-16 md:w-24 md:h-24 object-contain mt-10"
//         />
//       </div>

//       {/* ✅ MAIN HERO CONTENT */}
//       <div className="flex flex-col md:flex-row items-center justify-between w-full flex-grow max-w-7xl mx-auto mt-8 md:mt-0">
//         {/* LEFT SIDE CONTENT */}
//         <div
//           className="flex flex-col justify-center items-start text-left space-y-4 md:w-1/2"
//           data-aos="fade-right"
//         >
//           <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold leading-tight text-gray-900">
//             Transform Your Career <br />
//             <span className="text-fuchsia-600">with CSG Education</span>
//           </h1>

//           <p className="text-base md:text-lg text-gray-700 max-w-lg">
//             Master cutting-edge technologies with our industry-expert trainers.
//             Get job-ready skills in software & hardware development, multimedia,
//             and more.
//           </p>

//           {/* Stats */}
//           <div className="flex flex-row flex-wrap gap-4 pt-2">
//             <div className="bg-fuchsia-50 border border-fuchsia-200 rounded-2xl px-4 py-3 flex items-center gap-3 shadow-sm hover:shadow-fuchsia-200 transition-transform duration-300 hover:scale-105">
//               <Briefcase className="w-8 h-8 text-fuchsia-600 bg-fuchsia-100 rounded-full p-1" />
//               <div>
//                 <h4 className="text-lg md:text-xl font-semibold text-gray-900">
//                   100%
//                 </h4>
//                 <p className="text-sm text-gray-600">Placement Rate</p>
//               </div>
//             </div>

//             <div className="bg-purple-50 border border-purple-200 rounded-2xl px-4 py-3 flex items-center gap-3 shadow-sm hover:shadow-purple-200 transition-transform duration-300 hover:scale-105">
//               <Rocket className="w-8 h-8 text-purple-600 bg-purple-100 rounded-full p-1" />
//               <div>
//                 <h4 className="text-lg md:text-xl font-semibold text-gray-900">
//                   50+
//                 </h4>
//                 <p className="text-sm text-gray-600">Industry Partners</p>
//               </div>
//             </div>
//           </div>

//           {/* Buttons */}
//           <div className="flex flex-wrap gap-4 pt-2">
//             <Link to="/all-offeres">
//               <button
//                 className="relative bg-gradient-to-r from-fuchsia-500 via-pink-500 to-purple-500
//                 font-semibold px-6 py-3 text-sm md:text-base rounded-md shadow-md
//                 transition-transform duration-300 ease-in-out transform hover:scale-110 text-white"
//               >
//                 Courses Offered
//               </button>
//             </Link>

//             <Link to="/contact">
//               <button
//                 className="relative bg-gradient-to-r from-fuchsia-500 via-pink-500 to-purple-500
//                 font-semibold px-6 py-3 text-sm md:text-base rounded-md shadow-md
//                 transition-transform duration-300 ease-in-out transform hover:scale-110 text-white"
//               >
//                 Contact Us
//               </button>
//             </Link>
//           </div>
//         </div>

//         {/* ✅ RIGHT SIDE IMAGE */}
//         <div
//           className="md:w-1/2 flex justify-center md:justify-end mt-8 md:mt-0"
//           data-aos="fade-left"
//         >
//           <img
//             src="./assets/6be7f7756b8f4737a25c69f1086dfffb.jpg"
//             alt="Education Illustration"
//             className="w-64 h-64 md:w-[600px] md:h-[420px] object-contain drop-shadow-xl rounded-2xl"
//           />
//         </div>
//       </div>

//       {/* ✅ FOOTER SPACER */}
//       <div className="h-4 md:h-8"></div>
//     </section>
//   );
// }

// import React from "react";
// import { Rocket, Briefcase } from "lucide-react";
// import { Link } from "react-router-dom";

// export function HeroSection() {
//   return (
//     <section className="relative bg-sky-200 text-gray-900 min-h-screen flex flex-col items-center justify-between px-4 md:px-20 py-6 overflow-hidden">
//       {/* ✅ TOP HEADER BAR */}
//       <div className="w-full flex items-center justify-between flex-wrap gap-4 md:gap-0 mt-10 md:mt-6">
//         {/* Left Logo */}
//         <img
//           src="/left.png"
//           alt="Left Logo"
//           className="w-14 h-14 sm:w-16 sm:h-16 md:w-24 md:h-24 object-contain mt-10"
//         />

//         {/* Center Title */}
//         <Link
//           to="/"
//           style={{ animation: "zoomInOut 2.5s ease-in-out infinite" }}
//           className="text-2xl leading-fix sm:text-3xl md:text-5xl font-bold bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500
//           bg-clip-text text-transparent transition-all duration-300 hover:drop-shadow-md hover:scale-105 text-center flex-1 mt-10 pb-2 overflow-visible"
//         >
//           Authorised Training Centre
//         </Link>

//         {/* Right Logo */}
//         <img
//           src="/right.png"
//           alt="Right Logo"
//           className="w-14 h-14 sm:w-16 sm:h-16 md:w-24 md:h-24 object-contain mt-10"
//         />
//       </div>

//       {/* ✅ MAIN HERO CONTENT */}
//       <div className="flex flex-col md:flex-row items-center justify-between w-full flex-grow max-w-7xl mx-auto mt-8 md:mt-0">
//         {/* LEFT SIDE CONTENT */}
//         <div
//           className="flex flex-col justify-center items-center md:items-start text-center md:text-left space-y-4 md:w-1/2"
//           data-aos="fade-right"
//         >
//           <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold leading-tight text-gray-900">
//             Transform Your Career <br />
//             <span className="text-fuchsia-600">with CSG Education</span>
//           </h1>

//           <p className="text-base md:text-lg text-gray-700 max-w-lg">
//             Master cutting-edge technologies with our industry-expert trainers.
//             Get job-ready skills in software & hardware development, multimedia,
//             and more.
//           </p>

//           {/* Stats - Centered on mobile */}
//           <div className="flex flex-row flex-wrap justify-center md:justify-start gap-4 pt-2">
//             <div className="bg-fuchsia-50 border border-fuchsia-200 rounded-2xl px-5 py-3 flex items-center gap-3 shadow-sm hover:shadow-fuchsia-200 transition-transform duration-300 hover:scale-105">
//               <Briefcase className="w-9 h-9 text-fuchsia-600 bg-fuchsia-100 rounded-full p-1.5" />
//               <div>
//                 <h4 className="text-lg md:text-xl font-semibold text-gray-900">
//                   100%
//                 </h4>
//                 <p className="text-sm text-gray-600">Placement Rate</p>
//               </div>
//             </div>

//             <div className="bg-purple-50 border border-purple-200 rounded-2xl px-5 py-3 flex items-center gap-3 shadow-sm hover:shadow-purple-200 transition-transform duration-300 hover:scale-105">
//               <Rocket className="w-9 h-9 text-purple-600 bg-purple-100 rounded-full p-1.5" />
//               <div>
//                 <h4 className="text-lg md:text-xl font-semibold text-gray-900">
//                   50+
//                 </h4>
//                 <p className="text-sm text-gray-600">Industry Partners</p>
//               </div>
//             </div>
//           </div>

//           {/* Buttons */}
//           <div className="flex flex-wrap justify-center md:justify-start gap-4 pt-2">
//             <Link to="/all-offeres">
//               <button
//                 className="relative bg-gradient-to-r from-fuchsia-500 via-pink-500 to-purple-500
//                 font-semibold px-6 py-3 text-sm md:text-base rounded-md shadow-md
//                 transition-transform duration-300 ease-in-out transform hover:scale-110 text-white animate-pulse"
//               >
//                 Courses Offered
//               </button>
//             </Link>

//             <Link to="/contact">
//               <button
//                 className="relative bg-gradient-to-r from-fuchsia-500 via-pink-500 to-purple-500
//                 font-semibold px-6 py-3 text-sm md:text-base rounded-md shadow-md
//                 transition-transform duration-300 ease-in-out transform hover:scale-110 text-white animate-pulse"
//               >
//                 Contact Us
//               </button>
//             </Link>
//           </div>
//         </div>

//         {/* ✅ RIGHT SIDE IMAGE - Bigger on both mobile & desktop */}
//         <div
//           className="md:w-1/2 flex justify-center md:justify-end mt-10 md:mt-0"
//           data-aos="fade-left"
//         >
//           <img
//             src="./assets/6be7f7756b8f4737a25c69f1086dfffb.jpg"
//             alt="Education Illustration"
//             className="w-80 h-80 sm:w-[420px] sm:h-[350px] md:w-[680px] md:h-[480px] object-contain drop-shadow-xl rounded-2xl"
//           />
//         </div>
//       </div>

//       {/* ✅ FOOTER SPACER */}
//       <div className="h-4 md:h-8"></div>
//     </section>
//   );
// }

import React from "react";
import { Rocket, Briefcase } from "lucide-react";
import { Link } from "react-router-dom";

export function HeroSection() {
  return (
    <section className="relative bg-white text-gray-900 min-h-screen flex flex-col items-center justify-between px-4 md:px-20 py-6 overflow-hidden">
      {/* ✅ TOP HEADER BAR */}
      <div className="w-full flex items-center justify-between flex-wrap gap-4 md:gap-0 mt-10 md:mt-6">
        {/* Left Logo */}
        <img
          src="/left.png"
          alt="Left Logo"
          className="w-14 h-14 sm:w-16 sm:h-16 md:w-24 md:h-24 object-contain mt-10"
        />

        {/* Center Title */}
        <Link
          to="/"
          style={{ animation: "zoomInOut 2.5s ease-in-out infinite" }}
          className="text-2xl sm:text-3xl md:text-5xl font-bold bg-gradient-to-r from-blue-500 via-purple-500 to-pink-500 
          bg-clip-text text-transparent transition-all duration-300 hover:drop-shadow-md hover:scale-105 text-center flex-1 mt-10 pb-2 overflow-visible"
        >
          Authorised Training Centre
        </Link>

        {/* Right Logo */}
        <img
          src="/right.png"
          alt="Right Logo"
          className="w-14 h-14 sm:w-16 sm:h-16 md:w-24 md:h-24 object-contain mt-10"
        />
      </div>

      {/* ✅ MAIN HERO CONTENT */}
      <div className="flex flex-col md:flex-row items-center justify-between w-full flex-grow max-w-7xl mx-auto mt-8 md:mt-0">
        {/* LEFT SIDE CONTENT */}
        <div
          className="flex flex-col justify-center items-center md:items-start text-center md:text-left space-y-3 md:space-y-4 md:w-1/2"
          data-aos="fade-right"
        >
          {/* 1️⃣ Heading */}
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold leading-tight text-gray-900">
            Transform Your Career <br />
            <span className="text-fuchsia-600">with CSG Education</span>
          </h1>

          {/* 2️⃣ Image appears here in mobile view (hidden on desktop) */}

          <div className="w-full flex justify-center md:hidden mt-4 mb-4">
            <img
              src="./assets/6be7f7756b8f4737a25c69f1086dfffb.jpg"
              alt="Education Illustration"
              className="w-72 h-72 sm:w-[380px] sm:h-[300px] object-cover rounded-lg shadow-lg"
            />
          </div>

          {/* 3️⃣ Paragraph */}
          <p className="text-base md:text-lg text-gray-700 max-w-lg mt-0">
            Master cutting-edge technologies with our industry-expert trainers.
            Get job-ready skills in software & hardware development, multimedia,
            and more.
          </p>

          {/* 4️⃣ Stats */}
          <div className="flex flex-row flex-wrap justify-center md:justify-start gap-4 pt-1">
            <div className="bg-fuchsia-50 border border-fuchsia-200 rounded-2xl px-5 py-3 flex items-center gap-3 shadow-sm hover:shadow-fuchsia-200 transition-transform duration-300 hover:scale-105">
              <Briefcase className="w-9 h-9 text-fuchsia-600 bg-fuchsia-100 rounded-full p-1.5" />
              <div>
                <h4 className="text-lg md:text-xl font-semibold text-gray-900">
                  100%
                </h4>
                <p className="text-sm text-gray-600">Placement Rate</p>
              </div>
            </div>

            <div className="bg-purple-50 border border-purple-200 rounded-2xl px-5 py-3 flex items-center gap-3 shadow-sm hover:shadow-purple-200 transition-transform duration-300 hover:scale-105">
              <Rocket className="w-9 h-9 text-purple-600 bg-purple-100 rounded-full p-1.5" />
              <div>
                <h4 className="text-lg md:text-xl font-semibold text-gray-900">
                  50+
                </h4>
                <p className="text-sm text-gray-600">Industry Partners</p>
              </div>
            </div>
          </div>

          {/* 5️⃣ Buttons */}
          <div className="flex flex-wrap justify-center md:justify-start gap-4 pt-1">
            <Link to="/all-offeres">
              <button
                className="relative bg-gradient-to-r from-fuchsia-500 via-pink-500 to-purple-500 
                font-semibold px-6 py-3 text-sm md:text-base rounded-md shadow-md
                transition-transform duration-300 ease-in-out transform hover:scale-110 text-white animate-pulse"
              >
                Courses Offered
              </button>
            </Link>

            <Link to="/contact">
              <button
                className="relative bg-gradient-to-r from-fuchsia-500 via-pink-500 to-purple-500 
                font-semibold px-6 py-3 text-sm md:text-base rounded-md shadow-md
                transition-transform duration-300 ease-in-out transform hover:scale-110 text-white animate-pulse"
              >
                Contact Us
              </button>
            </Link>
          </div>
        </div>

        {/* ✅ RIGHT SIDE IMAGE (Desktop only) */}
        {/* <div
          className="hidden md:flex md:w-1/2 justify-center md:justify-end mt-10 md:mt-0 "
          data-aos="fade-left"
        >
          <img
            src="./assets/6be7f7756b8f4737a25c69f1086dfffb.jpg"
            alt="Education Illustration"
            className="w-[680px] h-[480px] object-contain drop-shadow-xl rounded-2xl "
          />
        </div> */}
        <div
          className="hidden md:flex md:w-1/2 justify-center md:justify-end mt-10 md:mt-0"
          data-aos="fade-left"
          data-aos-duration="1200"
        >
          <img
            src="./assets/6be7f7756b8f4737a25c69f1086dfffb.jpg"
            alt="Education Illustration"
            className="rounded-lg shadow-lg w-full h-auto max-h-[520px] object-cover"
          />
        </div>
      </div>

      {/* ✅ FOOTER SPACER */}
      <div className="h-4 md:h-8"></div>
    </section>
  );
}
